/* eslint-disable no-restricted-imports */
import { ProfanityWordsList } from '@/data/types/ProfanityWordsList';
import { useCallback, useMemo } from 'react';
import useSWR from 'swr';

const fetcher = async () => {
	const response = await fetch('/api/profanity_words_list');

	if (!response.ok) {
		throw new Error('Network response was not ok');
	}

	const data = await response.json();

	return data as ProfanityWordsList;
};

const GET_PROFANITY_WORDS_LIST_API = 'GET_PROFANITY_WORDS_LIST_API';

export const useForbiddenWords = () => {
	const { data, isLoading } = useSWR(GET_PROFANITY_WORDS_LIST_API, fetcher);

	const normalizeText = (text: string) =>
		text
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '')
			.toLowerCase();

	const escapeRegex = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

	const forbiddenWords = useMemo(() => data || [], [data]);

	const isContainForbiddenWords = useCallback(
		(text: string) => {
			if (forbiddenWords.length === 0 || text.trim() === '') return false;

			const normalized = normalizeText(text);
			const regex = new RegExp(`(${forbiddenWords.map(escapeRegex).join('|')})\\b`, 'gi');
			return forbiddenWords.includes(normalized) || regex.test(normalized);
		},
		[forbiddenWords]
	);

	return {
		isContainForbiddenWords,
		isLoading,
	};
};
